import { render, staticRenderFns } from "./ShippingPlanDetail.vue?vue&type=template&id=5742e988&scoped=true&"
import script from "./ShippingPlanDetail.vue?vue&type=script&lang=js&"
export * from "./ShippingPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPlanDetail.vue?vue&type=style&index=0&id=5742e988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742e988",
  null
  
)

export default component.exports